var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "primary-navigation" },
    _vm._l(_vm.menuItems, function(menuItem) {
      return _c(
        "li",
        {
          key: menuItem.title,
          ref: _vm.nodeRef(menuItem.title),
          refInFor: true,
          staticClass: "primary-navigation__node",
          on: {
            focusout: function($event) {
              return _vm.handleNodeFocusout(menuItem.title)
            },
            mouseleave: _vm.hideSubnav
          }
        },
        [
          _vm.hasSubnav(menuItem)
            ? _c(
                menuItem.url ? "a" : "div",
                {
                  tag: "div",
                  staticClass: "primary-navigation__link",
                  class:
                    _vm.toKebabCase(menuItem.title) === _vm.openSubnav
                      ? "primary-navigation__link--open-subnav"
                      : "",
                  attrs: {
                    tabindex: menuItem.url ? null : 0,
                    href: menuItem.url
                  },
                  on: {
                    mouseenter: function($event) {
                      _vm.showSubnav(_vm.toKebabCase(menuItem.title))
                    },
                    focus: function($event) {
                      _vm.showSubnav(_vm.toKebabCase(menuItem.title))
                    }
                  }
                },
                [_vm._v(_vm._s(menuItem.title))]
              )
            : _c(
                "a",
                {
                  staticClass: "primary-navigation__link",
                  attrs: { href: menuItem.url },
                  on: { mouseenter: _vm.hideSubnav, focus: _vm.hideSubnav }
                },
                [_vm._v(_vm._s(menuItem.title))]
              ),
          _vm.hasSubnav(menuItem)
            ? _c(
                "transition",
                { attrs: { name: "fade" } },
                [
                  _vm.openSubnav &&
                  _vm.openSubnav === _vm.toKebabCase(menuItem.title)
                    ? _c("subnav", {
                        key: _vm.toKebabCase(menuItem.title) + "_" + _vm._uid,
                        attrs: { menuItem: menuItem },
                        on: { blur: _vm.hideSubnav }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }